export const fillGapRegex = /(\[.*?\])/g;
